function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Button, Modal, Form, Input, Radio, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { formToScenarioParams } from '../ControlPanel/_helpers';
import client from '../../../feathers';
import Category from './Category';
import Type from './Type';
import Keywords from './Keywords';
var {
  TextArea
} = Input;

var CreateScenarioForm = (_ref) => {
  var {
    formVisible,
    scenario: {
      name,
      description,
      visible,
      category,
      type,
      keywords
    },
    onCreate,
    onCancel
  } = _ref;
  var [form] = Form.useForm();
  useEffect(() => {
    var fieldsValue = {
      name,
      description,
      category,
      type,
      visible,
      keywords: []
    };

    if (keywords && keywords !== '') {
      fieldsValue.keywords = keywords.split(',') || null;
    }

    form.setFieldsValue(fieldsValue);
  }, [form, name, description, category, type, visible, keywords]);
  return /*#__PURE__*/React.createElement(Modal, {
    visible: formVisible,
    title: "Save scenario",
    okText: "Save",
    cancelText: "Cancel",
    onCancel: onCancel,
    onOk: () => {
      form.validateFields().then(values => {
        if (values.keywords) {
          return onCreate(_objectSpread(_objectSpread({}, values), {}, {
            keywords: values.keywords.join(',')
          }));
        }

        return onCreate(values);
      }).catch(info => {
        console.log('Validate Failed:', info);
      });
    }
  }, /*#__PURE__*/React.createElement(Form, {
    form: form,
    layout: "vertical",
    name: "form_in_modal",
    initialValues: {
      name,
      description,
      visible,
      category,
      keywords: keywords ? keywords.split(',') : []
    }
  }, /*#__PURE__*/React.createElement(Form.Item, {
    name: "name",
    label: "Scenario Name",
    rules: [{
      required: true,
      message: 'Please input the name of the scenario.'
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    name: "description",
    label: "Description",
    rules: [{
      required: true,
      message: 'Please input a description. Min 100 characters.'
    }, {
      min: 20,
      validateTrigger: 'onFinish'
    }]
  }, /*#__PURE__*/React.createElement(TextArea, null)), /*#__PURE__*/React.createElement(Category, null), /*#__PURE__*/React.createElement(Type, null), /*#__PURE__*/React.createElement(Keywords, null), /*#__PURE__*/React.createElement(Form.Item, {
    name: "visible",
    label: "Visible"
  }, /*#__PURE__*/React.createElement(Radio.Group, null, /*#__PURE__*/React.createElement(Radio, {
    value: true
  }, "Visible"), /*#__PURE__*/React.createElement(Radio, {
    value: false
  }, "Not Visible")))));
};

function createOrUpdateParameters(_x, _x2) {
  return _createOrUpdateParameters.apply(this, arguments);
}

function _createOrUpdateParameters() {
  _createOrUpdateParameters = _asyncToGenerator(function* (scenarioId, parameters) {
    parameters.forEach(param => {
      var obj = _objectSpread(_objectSpread({}, param), {}, {
        scenarioId
      });

      return client.service('scenario-parameters').create(obj);
    });
  });
  return _createOrUpdateParameters.apply(this, arguments);
}

function createOrUpdateScenario(_x3) {
  return _createOrUpdateScenario.apply(this, arguments);
}

function _createOrUpdateScenario() {
  _createOrUpdateScenario = _asyncToGenerator(function* (data) {
    var key = 'create-or-update-scenario';
    var {
      scenarioId,
      parameters
    } = data;

    if (scenarioId) {
      message.loading({
        content: 'Updating scenario...',
        key
      });
      yield client.service('scenarios').patch(scenarioId, data);
      yield createOrUpdateParameters(scenarioId, parameters);
      return message.success({
        content: 'Updated!',
        key,
        duration: 2
      });
    }

    message.loading({
      content: 'Creating scenario...',
      key
    });
    var scenario = yield client.service('scenarios').create(data);
    yield createOrUpdateParameters(scenario.scenarioId, parameters);
    return message.success({
      content: 'Created!',
      key,
      duration: 2
    });
  });
  return _createOrUpdateScenario.apply(this, arguments);
}

var warning = () => {
  message.warning('Please add parameters before saving.');
};

var CreateScenario = (_ref2) => {
  var {
    scenario,
    form
  } = _ref2;
  var [visible, setVisible] = useState(false);

  var onCreate = values => {
    var currentFormValues = form.getFieldsValue();
    var parameters = formToScenarioParams(currentFormValues);

    if (_.isEmpty(parameters)) {
      return warning();
    }

    var createOrUpdate = _objectSpread(_objectSpread(_objectSpread({}, scenario), values), {}, {
      parameters
    });

    setVisible(false);
    return createOrUpdateScenario(createOrUpdate);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    icon: /*#__PURE__*/React.createElement(SaveOutlined, null),
    disabled: !scenario,
    onClick: () => {
      setVisible(true);
    }
  }), scenario && /*#__PURE__*/React.createElement(CreateScenarioForm, {
    scenario: scenario,
    formVisible: visible,
    onCreate: onCreate,
    onCancel: () => {
      setVisible(false);
    }
  }));
};

export default CreateScenario;